/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { SelectFilter } from '../../components/inputs/filters/select';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';
import { RowIdentity } from '../../components/ui';

export function UsersPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { requestApi: reqApiGroup, data: dataGroups } = useFetch(`${baseApiUrl}/groups`);

  useEffect(() => {
    reqApiGroup('get');
  }, []);

  const columns = [
    { name: 'name', label: 'Nome' },
    { name: 'group.name', label: 'Grupo' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Box>
      <PageTitle description="Quem acessa o painel, com qual grupo e em qual escopo.">
        Usuários
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        columnWithAction={[
          {
            name: 'name',
            columnAction: (rowItem) => (
              <RowIdentity
                title={rowItem?.name}
                meta={rowItem?.email}
                image={rowItem?.image?.medium}
              />
            ),
          },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
          {
            name: 'group_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar grupo',
            isSearchable: true,
            onInputChange: (value) => {
              reqApiGroup('get', { params: { search: value } });
            },
            options: [
              ...(dataGroups?.data?.map((item) => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
          // {
          //   name: 'institution_id',
          //   filterComponent: SelectFilter,
          //   placeholder: 'Selecionar instituição',
          //   isSearchable: true,
          //   onInputChange: value => {
          //     reqApiInstitution('get', { params: { search: value } });
          //   },
          //   options: [
          //     ...(dataInstitution?.data?.map(item => ({
          //       label: item?.name,
          //       value: item?.id,
          //     })) ?? []),
          //   ],
          // },
        ]}
      />
    </Box>
  );
}
